import React, { Fragment } from 'react';
import {
  useMediaQuery,
  useTheme,
} from '@mui/material';
import styles from './RenderTable.module.css';

const PairBlock = ({ label, value }) => (
  <div className={styles.pairBlock}>
    <div className={styles.label}>{label}</div>
    <div className={styles.value}>{value}</div>
  </div>
);

const RenderTable = ({ entries = [], cols = 2 }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // set theme colors into CSS variables on the container so the CSS module can use them
  const cssVars = {
    '--rt-white-text': theme.palette?.whiteText?.main || '#F0E5D5',
    '--rt-secondary': theme.palette?.secondary?.main || '#F09C20',
  };

  if (isMobile || cols < 2) {
    // mobile: use the same PairBlock but stacked as single-row "table" (label + value)
    return (
      <div className={styles.mobileContainer} style={cssVars}>
        {entries.map((entry, idx) => (
          <PairBlock
            key={idx}
            label={entry ? entry[0] : ''}
            value={entry && entry[1] != null ? String(entry[1]) : ''}
          />
        ))}
      </div>
    );
  }

  // desktop/tablet: grid with 2 columns, left/right entries aligned per row index
  const rowsPerCol = Math.ceil(entries.length / cols);
  const leftEntries = entries.slice(0, rowsPerCol);
  const rightEntries = entries.slice(rowsPerCol);

  return (
    <div className={styles.containerGrid} style={cssVars}>
      {Array.from({ length: rowsPerCol }).map((_, rowIndex) => {
        const left = leftEntries[rowIndex];
        const right = rightEntries[rowIndex];

        return (
          <Fragment key={rowIndex}>
            <PairBlock
              label={left ? left[0] : ''}
              value={left && left[1] != null ? String(left[1]) : ''}
            />
            <PairBlock
              label={right ? right[0] : ''}
              value={right && right[1] != null ? String(right[1]) : ''}
            />
          </Fragment>
        );
      })}
    </div>
  );
};

export default RenderTable;